import { render, staticRenderFns } from "./CadastroCheckboxSn.vue?vue&type=template&id=0a773142&scoped=true&lang=pug&"
import script from "./CadastroCheckboxSn.vue?vue&type=script&lang=js&"
export * from "./CadastroCheckboxSn.vue?vue&type=script&lang=js&"
import style0 from "./CadastroCheckboxSn.vue?vue&type=style&index=0&id=0a773142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a773142",
  null
  
)

export default component.exports